import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';
import conflictFields from '../../../../constants/conflictFields';
import { TextQuestionParameters } from '../../questionParameters';

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Email = ({
  source,
  extraParameters,
}: {
  source?: string;
  extraParameters?: TextQuestionParameters;
}) => (
  <Answer
    label={extraParameters?.label ?? 'Email'}
    source={source ?? 'email'}
    datapoint={conflictFields.EMAIL}
    identificationInfo={undefined}
  >
    <ValueField />
  </Answer>
);

Email.ValueField = ValueField;

export default Email;
